var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDownDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    rx: 10,
    transform: "rotate(-180 20 20)",
    fill: "#4C5161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_901_3038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-180 20 20)",
    fill: "#D052FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_901_3038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 12.6668L13.2497 10.2501C13.4025 10.0973 13.5969 10.021 13.833 10.021C14.0691 10.021 14.2636 10.0973 14.4163 10.2501C14.5691 10.4029 14.6455 10.5973 14.6455 10.8335C14.6455 11.0696 14.5691 11.264 14.4163 11.4168L10.583 15.2501C10.4163 15.4168 10.2219 15.5001 9.99967 15.5001C9.77745 15.5001 9.58301 15.4168 9.41634 15.2501L5.58301 11.4168C5.43023 11.264 5.35384 11.0696 5.35384 10.8335C5.35384 10.5973 5.43023 10.4029 5.58301 10.2501C5.73579 10.0973 5.93023 10.021 6.16634 10.021C6.40245 10.021 6.5969 10.0973 6.74967 10.2501L9.16634 12.6668V5.83346C9.16634 5.59734 9.2462 5.39943 9.40592 5.23971C9.56565 5.07998 9.76356 5.00012 9.99967 5.00012C10.2358 5.00012 10.4337 5.07998 10.5934 5.23971C10.7531 5.39943 10.833 5.59734 10.833 5.83346L10.833 12.6668Z",
    fill: "#1C203B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownDisabled);
export default __webpack_public_path__ + "static/media/sort-down-disabled.eacca0cd1140a7304d27531ab967e6af.svg";
export { ForwardRef as ReactComponent };